import { useId, type ReactNode } from "react";
import "./about-box.css";

type Props = { title: string; children: ReactNode };

// Il riquadro «A cosa serve». Un blocco è un titolo e un paragrafo: per affiancarne un secondo («Chi
// decide») si aggiungono in coda un <h2> e un <p>, e su schermo largo stanno in due colonne.
export function AboutBox({ title, children }: Props) {
  const titleId = useId();
  return (
    <section className="g-about" aria-labelledby={titleId}>
      <h2 id={titleId}>{title}</h2>
      {children}
    </section>
  );
}
